import { formatDisplayDate } from "syf-js-utilities";
var getSubAdditionalInfoForPeriods = function (isClosedORPreDelivery, t, isActiveIRL, promoExpiryDate) {
    var subAdditionalInfoForPeriods = {};
    if (!isClosedORPreDelivery) {
        if (isActiveIRL) {
            subAdditionalInfoForPeriods = {
                introPeriodInfo: {
                    displayText: t("introRateLoan.introStatusActive"),
                    status: "active",
                },
            };
        }
        else {
            subAdditionalInfoForPeriods = {
                introPeriodInfo: {
                    displayText: "".concat(t("grid.labels.promotionStatus.expired"), " ").concat(promoExpiryDate ? "(".concat(formatDisplayDate(promoExpiryDate), ")") : ""),
                    status: "expired",
                },
                postIntroPeriodInfo: {
                    displayText: t("introRateLoan.introStatusActive"),
                    status: "active",
                },
            };
        }
    }
    return subAdditionalInfoForPeriods;
};
export default getSubAdditionalInfoForPeriods;
//# sourceMappingURL=getSubAdditionalInfoForPeriods.js.map